import { Routes } from '@angular/router';
import { authGuard, guestGuard, homeRedirectGuard, permissionGuard } from './core/auth/auth.guard';

const RDA_READ = ['RDA_READ_OWN', 'RDA_READ_ALL', 'RDA_READ_APPROVED'];

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    title: 'Accesso · Guerra',
    loadComponent: () => import('./features/auth/login').then((m) => m.Login),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./core/layout/shell').then((m) => m.Shell),
    children: [
      { path: '', pathMatch: 'full', canActivate: [homeRedirectGuard], children: [] },
      {
        path: 'rda',
        children: [
          {
            path: '',
            pathMatch: 'full',
            canActivate: [permissionGuard(...RDA_READ)],
            title: 'Richieste di acquisto · Guerra',
            loadComponent: () => import('./features/rda/rda-list').then((m) => m.RdaList),
          },
          {
            path: 'nuova',
            canActivate: [permissionGuard('RDA_CREATE')],
            title: 'Nuova richiesta · Guerra',
            loadComponent: () => import('./features/rda/rda-form').then((m) => m.RdaForm),
          },
          {
            path: 'approvazioni',
            canActivate: [permissionGuard('RDA_APPROVE', 'RDA_QUEUE_READ')],
            title: 'Approvazioni · Guerra',
            loadComponent: () => import('./features/rda/approval-queue').then((m) => m.ApprovalQueuePage),
          },
          {
            path: 'acquisti',
            canActivate: [permissionGuard('RDA_PURCHASING', 'RDA_QUEUE_READ')],
            title: 'Gestione Acquisti · Guerra',
            loadComponent: () => import('./features/rda/purchasing').then((m) => m.PurchasingPage),
          },
          {
            path: 'dashboard',
            canActivate: [permissionGuard('DASHBOARD_RDA')],
            title: 'Cruscotto RdA · Guerra',
            loadComponent: () => import('./features/rda/rda-dashboard').then((m) => m.RdaDashboard),
          },
          {
            path: ':id/modifica',
            canActivate: [permissionGuard('RDA_CREATE')],
            title: 'Modifica richiesta · Guerra',
            loadComponent: () => import('./features/rda/rda-form').then((m) => m.RdaForm),
          },
          {
            path: ':id',
            canActivate: [permissionGuard(...RDA_READ)],
            title: 'Richiesta · Guerra',
            loadComponent: () => import('./features/rda/rda-detail').then((m) => m.RdaDetailPage),
          },
        ],
      },
      // CRM disattivato: l'app gestisce per ora solo le RdA. Per riattivare il CRM decommentare queste rotte
      // {
      //   path: 'crm',
      //   children: [
      //     { path: 'dashboard', canActivate: [permissionGuard('DASHBOARD_CRM')], title: 'Dashboard commerciale · Guerra',
      //       loadComponent: () => import('./features/crm/crm-dashboard').then((m) => m.CrmDashboard) },
      //     { path: 'clienti', canActivate: [permissionGuard('CRM_CUSTOMER_READ')], title: 'Clienti · Guerra',
      //       loadComponent: () => import('./features/crm/customer-list').then((m) => m.CustomerList) },
      //     { path: 'clienti/:id', canActivate: [permissionGuard('CRM_CUSTOMER_READ')], title: 'Scheda cliente · Guerra',
      //       loadComponent: () => import('./features/crm/customer-360').then((m) => m.Customer360) },
      //     { path: 'opportunita', canActivate: [permissionGuard('CRM_CUSTOMER_READ')], title: 'Opportunità · Guerra',
      //       loadComponent: () => import('./features/crm/opportunities').then((m) => m.Opportunities) },
      //     { path: 'campioni', canActivate: [permissionGuard('CRM_CUSTOMER_READ')], title: 'Campioni · Guerra',
      //       loadComponent: () => import('./features/crm/samples').then((m) => m.Samples) },
      //     { path: 'richieste-tecniche', canActivate: [permissionGuard('CRM_CUSTOMER_READ')], title: 'Richieste tecniche · Guerra',
      //       loadComponent: () => import('./features/crm/tech-requests').then((m) => m.TechRequests) },
      //     { path: 'lead', canActivate: [permissionGuard('CRM_LEAD_MANAGE', 'CRM_LEAD_READ')], title: 'Lead · Guerra',
      //       loadComponent: () => import('./features/crm/leads').then((m) => m.Leads) },
      //     { path: 'catalogo', canActivate: [permissionGuard('CRM_CUSTOMER_READ')], title: 'Catalogo · Guerra',
      //       loadComponent: () => import('./features/crm/catalog').then((m) => m.Catalog) },
      //     { path: 'catalogo/:id', canActivate: [permissionGuard('CRM_CUSTOMER_READ')], title: 'Prodotto · Guerra',
      //       loadComponent: () => import('./features/crm/product-detail').then((m) => m.ProductDetailPage) },
      //   ],
      // },
      {
        path: 'admin',
        children: [
          {
            path: 'utenti',
            canActivate: [permissionGuard('ADMIN_USERS')],
            title: 'Utenti e ruoli · Guerra',
            loadComponent: () => import('./features/admin/users-roles').then((m) => m.UsersRoles),
          },
          {
            path: 'anagrafiche',
            canActivate: [permissionGuard('MASTERDATA_WRITE', 'MASTERDATA_VIEW')],
            title: 'Anagrafiche · Guerra',
            loadComponent: () => import('./features/admin/master-data').then((m) => m.MasterData),
          },
          {
            path: 'registro',
            canActivate: [permissionGuard('AUDIT_READ')],
            title: 'Registro attività · Guerra',
            loadComponent: () => import('./features/admin/audit-log').then((m) => m.AuditLog),
          },
        ],
      },
      {
        path: 'non-autorizzato',
        title: 'Accesso negato · Guerra',
        loadComponent: () => import('./features/errors/not-authorized').then((m) => m.NotAuthorized),
      },
      {
        path: '**',
        title: 'Non trovata · Guerra',
        loadComponent: () => import('./features/errors/not-found').then((m) => m.NotFound),
      },
    ],
  },
];
